import React from 'react';
import { Container, Paper, Toolbar, Box } from '@mui/material';
import { Routes, Route } from 'react-router-dom';

import Me from './me';

/**
 * Security module router component handling routes for user profile/security settings.
 */
export default function SecurityIndex() {
  return (
    <>
      <Toolbar />
      <Container maxWidth="xl">
        <Paper>
          <Box p={2}>
            <Routes>
              <Route path="me" element={<Me />} />
            </Routes>
          </Box>
        </Paper>
      </Container>
    </>
  );
}
